import { aggregateFindings } from "@nexus/contracts";
import type { CriterionFinding } from "@nexus/contracts";

import type { PreflightReportDetail } from "../types/preflight.types";
import { scoredReportAssets } from "./report-blockers";

export type { CriterionFinding } from "@nexus/contracts";

/**
 * The sub-checks that failed across a report's scored creatives, most widespread first.
 * Report-shaped entry point only — the aggregation lives in `@nexus/contracts` alongside the
 * blocker and attribution maths so the exports and the PDF can adopt it unchanged.
 */
export function computeReportFindings(
  report: PreflightReportDetail,
): CriterionFinding[] {
  return aggregateFindings(
    scoredReportAssets(report).map((asset) => asset.features),
  );
}
